import type { DateRange } from "@mui/x-date-pickers-pro"
import type { Dayjs } from "dayjs"
import type React from "react"
import { createContext, useContext, useMemo, useState } from "react"
import { dayjsUTC } from "../../utils/dates"

interface WastewaterContextType {
  dateRange: DateRange<Dayjs>
  setDateRange: (dateRange: DateRange<Dayjs>) => void
  selectedAnomalyKey: string | null
  setSelectedAnomalyKey: (selectedAnomalyKey: string | null) => void
}

const WastewaterContext = createContext<WastewaterContextType | undefined>(
  undefined
)

export const WastewaterProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [dateRange, setDateRange] = useState<DateRange<Dayjs>>([
    dayjsUTC(dayjsUTC().endOf("week").subtract(1, "year").format("YYYY-MM-DD")),
    dayjsUTC(dayjsUTC().endOf("week").format("YYYY-MM-DD")),
  ])

  const [selectedAnomalyKey, setSelectedAnomalyKey] = useState<string | null>(
    null
  )

  const value = useMemo(
    () => ({
      dateRange,
      setDateRange,
      selectedAnomalyKey,
      setSelectedAnomalyKey,
    }),
    [dateRange, selectedAnomalyKey]
  )

  return (
    <WastewaterContext.Provider value={value}>
      {children}
    </WastewaterContext.Provider>
  )
}

export function useWastewaterContext(): WastewaterContextType {
  const context = useContext(WastewaterContext)
  if (context === undefined) {
    throw new Error(
      "useWastewaterContext must be used within a WastewaterProvider"
    )
  }
  return context
}
